import RestClientProvider from '@tgtg/core/api/RestClientProvider';

import RestClient from './axios';

// Configure @tgtg/core to use our axios instance
RestClientProvider.setDefault(RestClient);

export default RestClientProvider;
